<template>
  <v-select
    v-model="selectedPaymentType"
    :items="paymentsTypesList"
    item-text="text"
    item-value="id"
    placeholder="Tipo de Pago"
    label="Tipo de Pago"
    outlined
    dense
    :clearable="clearable"
  >
    <template #item="{ item }">
      <v-list-item-icon>
        <v-icon :color="item.color">
          {{ item.icon }}
        </v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{ item.text }}</v-list-item-title>
      </v-list-item-content>
    </template>

    <template #selection="{ item }">
      <v-list-item-icon class="pb-0 pt-0 mt-1 mb-0">
        <v-icon :color="item.color">
          {{ item.icon }}
        </v-icon>
      </v-list-item-icon>
      <v-list-item-content class="pb-0 pt-0 mt-0 mb-0">
        <v-list-item-title>{{ item.text }}</v-list-item-title>
      </v-list-item-content>
    </template>
  </v-select>
</template>

<script>
import { computed } from '@vue/composition-api'
import usePaymentsTypesList from '@/components/lists/paymentsTypes'

export default {
  props: {
    default: {
      type: Number,
      default: null,
    },
    value: {
      type: Number,
      default: null,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { paymentsTypesList } = usePaymentsTypesList()
    const selectedPaymentType = computed({
      get() {
        return props.value
      },
      set(value) {
        // Actualiza el valor del componente y emite el evento "input"
        // para mantener sincronizado el valor con v-model
        return emit('input', value)
      },
    })

    const Reset = () => {
      emit('input', props.default)
    }

    return {
      selectedPaymentType,
      paymentsTypesList,
      Reset,
    }
  },
}
</script>
